import { render, staticRenderFns } from "./M2hConsent.vue?vue&type=template&id=0b66e774&scoped=true&"
import script from "./M2hConsent.vue?vue&type=script&lang=js&"
export * from "./M2hConsent.vue?vue&type=script&lang=js&"
import style0 from "./M2hConsent.vue?vue&type=style&index=0&id=0b66e774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66e774",
  null
  
)

export default component.exports